import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { formatErr } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50"><Navbar/>
    <div className="max-w-md mx-auto pt-16 px-4">
      <Card className="p-8">
        <h1 className="heading text-2xl font-extrabold text-slate-900">Password dimenticata</h1>
        <p className="text-sm text-slate-600 mt-2">Ti invieremo un codice di reset via email</p>
        {sent ? (
          <div className="mt-6 bg-emerald-50 border border-emerald-200 text-emerald-800 p-4 rounded" data-testid="forgot-sent">
            Se l'email esiste, ti abbiamo inviato un codice. <Link to="/reset-password" className="underline">Inserisci il codice qui</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <Input type="email" required placeholder="La tua email" value={email} onChange={e=>setEmail(e.target.value)} data-testid="forgot-email"/>
            <Button disabled={busy} className="w-full bg-blue-800" data-testid="forgot-submit">Invia codice</Button>
          </form>
        )}
      </Card>
    </div></div>
  );
}

export function ResetPassword() {
  const [token, setToken] = useState("");
  const [newp, setNewp] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newp });
      setDone(true);
      toast.success("Password reimpostata");
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50"><Navbar/>
    <div className="max-w-md mx-auto pt-16 px-4">
      <Card className="p-8">
        <h1 className="heading text-2xl font-extrabold text-slate-900">Reimposta password</h1>
        {done ? (
          <div className="mt-6 bg-emerald-50 border border-emerald-200 text-emerald-800 p-4 rounded">
            Password aggiornata! <Link to="/login" className="underline">Accedi</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <Input required placeholder="Codice ricevuto" value={token} onChange={e=>setToken(e.target.value)} data-testid="reset-token"/>
            <Input type="password" required minLength={6} placeholder="Nuova password" value={newp} onChange={e=>setNewp(e.target.value)} data-testid="reset-newp"/>
            <Button disabled={busy} className="w-full bg-blue-800" data-testid="reset-submit">Reimposta</Button>
          </form>
        )}
      </Card>
    </div></div>
  );
}
